import { Component, computed, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@cmi/addin-core';
import * as wordControls from '../../../lib/word-content-controls';
import { ContentControlItem } from '../../shared/content-control-item/content-control-item';

@Component({
  selector: 'cmi-used-controls',
  imports: [TranslatePipe, ContentControlItem],
  templateUrl: './used-controls.html'
})
export class UsedControls implements OnInit {
  protected readonly controls = signal<wordControls.ContentControlInfo[]>([]);
  protected readonly isLoading = signal<boolean>(false);
  protected readonly error = signal<string | null>(null);

  protected readonly cmiControls = computed(() =>
    this.controls().filter((c) => c.title?.startsWith('CMI_') || c.title?.startsWith('ITEM.'))
  );

  protected readonly reportControls = computed(() =>
    this.controls().filter((c) => c.title?.startsWith('CMR_'))
  );

  public ngOnInit(): void {
    void this.loadControls();
  }

  protected async loadControls(): Promise<void> {
    this.isLoading.set(true);
    this.error.set(null);

    try {
      const allControls = await wordControls.getAllContentControls();
      const relevantControls = allControls.filter(
        (control) =>
          control.title?.startsWith('CMI_') ||
          control.title?.startsWith('ITEM.') ||
          control.title?.startsWith('CMR_')
      );
      const sortedControls = relevantControls.sort((a, b) => {
        const titleA = (a.title || '').toLowerCase();
        const titleB = (b.title || '').toLowerCase();
        return titleA.localeCompare(titleB);
      });
      this.controls.set(sortedControls);
    } catch (err) {
      console.error('Error loading content controls:', err);
      this.error.set('Failed to load content controls');
    } finally {
      this.isLoading.set(false);
    }
  }

  protected async selectControl(id: number): Promise<void> {
    try {
      await wordControls.selectContentControl(id);
    } catch (err) {
      console.error('Error selecting content control:', err);
      this.error.set('Failed to select content control');
    }
  }
}
